// Membership Education screens select different subsets of the same
// `me.lifelongLearning` object, which has no id of its own. Merging keeps one
// screen's response from replacing the fields another mounted screen reads.
const mergeFields = (...fieldNames) => ({
  fields: fieldNames.reduce(
    (fields, fieldName) => ({ ...fields, [fieldName]: { merge: true } }),
    {},
  ),
})

export const lifelongLearningTypePolicies = {
  MembershipPerson: mergeFields("lifelongLearning"),
  LifelongLearningProfile: mergeFields("spp", "cpp", "mpp"),
  LifelongLearningProgram: mergeFields(
    "application",
    "careerPath",
    "eligibility",
    "progress",
  ),
  LifelongLearningApplication: mergeFields("careerPath"),
  LifelongLearningProgress: mergeFields("latestSubscription"),
}
